import { createContext, useContext, ReactNode } from 'react';

export interface RoomFilterValues {
  floorIdFilter?: string; // Filter rooms to only show those on this floor
  excludeRoomIds?: string[]; // Exclude these room IDs from options
}

const RoomFilterContext = createContext<RoomFilterValues | undefined>(undefined);

export interface RoomFilterProviderProps {
  children: ReactNode;
  filterValues: RoomFilterValues;
}

export const RoomFilterProvider = ({ children, filterValues }: RoomFilterProviderProps) => {
  return <RoomFilterContext.Provider value={filterValues}>{children}</RoomFilterContext.Provider>;
};

export const useRoomFilterValues = (): RoomFilterValues => {
  return useContext(RoomFilterContext) ?? {};
};
